export const getPaginationConfig = (response, pageSize) => {
  if (!response) {
    return null;
  }
  
  const currentPageIndex = response.number || 0;
  const totalElements = response.totalElements || 0;
  const totalPages = response.totalPages || 0;
  const currentPageNumber = currentPageIndex + 1;
  const startElement = totalElements > 0 ? (currentPageIndex * pageSize) + 1 : 0;
  const endElement = Math.min(startElement + pageSize - 1, totalElements);
  
  return {
    totalElements,
    totalPages,
    currentPageNumber,
    currentPageIndex,
    startElement,
    endElement,
    hasNext: response.hasNext,
    hasPrevious: response.hasPrevious,
    isFirst: response.first,
    isLast: response.last
  };
};

